import controlledDisbursementsGridLocale from 'components/controlledDisbursementsGrid/controlledDisbursementsGrid.locale';
import controlledDisbursementsWidgetLocale from 'components/widgets/controlledDisbursementsWidget/controlledDisbursementsWidget.locale';
import deliveryPoints from 'components/deliveryPoints/DeliveryPoints.locale';
import viewFileImport from 'components/importManager/viewFileImport.locale';
import checkfreeLocale from 'components/checkfree/checkfree.locale';
import financialOverviewLocale from 'components/widgets/financialOverview/FinancialOverview.locale';
import initiateForm from 'components/paymentTemplates/paymentTemplateInitiateMultipleACH/InitiateMultipleACH.locale';
import smbLoanTemplate from 'components/widgets/smallBusinessPayments/loanTemplates/SMBLoanTemplate.locale';
import TransferServiceMessage from 'components/transferServiceMessage/TransferServiceMessage.locale';
import accountActivity from '../accountActivity/accountActivity.locale';
import accountDetails from '../balanceAndTransactions/accountDetails/AccountDetails.locale';
import accountSummaryWidget from '../widgets/accountSummaryWidget/accountSummaryWidget.locale';
import ach from '../widgets/achPassThru/ACHPassThru.locale';
import achPayment from '../ach/ach.locale';
import achPosPay from '../widgets/achPosPay/achPosPay.locale';
import achTotals from '../widgets/achTotals/ACHTotals.locale';
import addContactLocale from '../addContact/AddContact.locale';
import alertsList from '../alertsList/alertsList.locale';
import allAccounts from '../allAccounts/allAccounts.locale';
import assignAlerts from '../assignAlerts/assignAlerts.locale';
import assignServices from '../assignServices/assignServices.locale';
import auditReport from '../widgets/auditReport/auditReport.locale';
import balanceAndTransactions from '../balanceAndTransactions/workspace/BalanceAndTransactions.locale';
import balanceTransactionSearchForm from '../balanceTransactionSearchForm/BalanceTransactionSearchForm.locale';
import beforeAfterDayRadio from '../beforeAfterDayRadio/BeforeAfterDayRadio.locale';
import btrAccountsDropDown from '../btrAccountsDropDown/btrAccountsDropDown.locale';
import bulletinsLocale from '../bulletins/bulletins.locale';
import cashFlowForecastingLocale from '../widgets/cashFlowForecasting/cashFlowForecasting.locale';
import checkImageDetails from '../checkImageDetails/checkImageDetails.locale';
import checkIssueManagementLocale from '../widgets/checkIssueManagement/checkIssueManagement.locale';
import commonLocale from './common.locale';
import contactCenterLocale from '../contactCenterWorkspace/contactCenter.locale';
import contactCenterApprovePayeeLocale from '../contactCenterApprovePayee/contactCenterApprovePayee.locale';
import contactCenterListViewLocale from '../widgets/contactCenterListView/contactCenterListView.locale';
import contactCenterUserLocale from '../contactCenterUser/contactCenterUser.locale';
import createPaymentLocale from '../createPayment/createPayment.locale';
import createTransfersLocale from '../createTransfers/createTransfers.locale';
import customReporting from '../customReporting/CustomReporting.locale';
import dateTimeLocale from './dateTime.locale';
import daymonthorweek from '../dayMonthOrWeek/daymonthorweek.locale';
import depositAccountDetailsLocale from '../balanceAndTransactions/accountDetails/deposit/web/depositAccountDetails.locale';
import depositAccountsLocale from '../balanceAndTransactions/depositAccounts/web/depositAccounts.locale';
import depositSlip from '../depositSlip/depositSlip.locale';
import deviceChallengeLocale from '../deviceChallenge/deviceChallenge.locale';
import dropZoneLocale from '../dropZone/dropZone.locale';
import dynamicLink2 from '../dynamicLink2/dynamicLink2.locale';
import electronicreportsGridLocale from '../electronicReportsGrid/electronicReportsGrid.locale';
import employeePaymentsLocale from '../employeePayments/employeePayments.locale';
import failedImportDetailsLocale from '../failedImportDetails/failedImportDetails.locale';
import FdicLogoLocale from '../fdicLogo/FdicLogo.locale';
import firstTimeLoginFlowLocale from '../firstTimeLoginFlow/firstTimeLoginFlow.locale';
import gridDatePicker from '../gridDatePicker/GridDatePicker.locale';
import importBatchLocale from '../importBatchDetails/importBatch.locale';
import importBatchesGrid from '../paymentTemplateImport/ImportBatchesGrid.locale';
import importFile from '../paymentTemplateImport/ImportFile.locale';
import importIssueFiles from '../importIssueFiles/importIssueFiles.locale';
import importIssueDetails from '../importIssueDetails/importIssueDetails.locale';
import importMapping from '../importMapping/importMapping.locale';
import importPayment from '../importPayment/importPayment.locale';
import issuesVoids from '../issuesVoids/issuesVoids.locale';
import paymentRule from '../paymentRule/PaymentRule.locale';
import limits from '../limits/limits.locale';
import login from '../login/Login.locale';
import loanAccountDetails from '../balanceAndTransactions/accountDetails/loan/web/loanAccountDetails.locale';
import loanPaymentTemplateWorkflow from '../loanPaymentTemplate/locale.ts';
import loanAccountDetailsTabs from '../loanAccountDetailsTabs/loanAccountDetailsTabs.locale';
import loanAccountsLocale from '../balanceAndTransactions/loanAccounts/web/loanAccounts.locale';
import mobileRemoteDepositCheckCapture from '../mobileRemoteDepositCheckCapture/Mrdc.locale';
import monthlyscheduler from '../monthlyScheduler/monthlyscheduler.locale';
import newUser from '../newUser/newUser.locale';
import nicknames from '../nicknames/nicknames.locale';
import notifications from '../widgets/notifications/Notifications.locale';
import paymentAdditionalDetails from '../wirePayment/partials/PaymentAdditionalDetails.locale';
import paymentDetails from '../wirePayment/partials/PaymentDetails.locale';
import paymentFraudControlGridLocale from '../paymentFraudControlGrid/paymentFraudControlGrid.locale';
import paymentFraudControlLocale from '../widgets/paymentFraudControl/paymentFraudControl.locale';
import paymentFraudControlSummaryGridLocale from '../paymentFraudControlSummaryGrid/paymentFraudControlSummaryGrid.locale';
import paymentRuleModificationsLocale from '../paymentRuleModifications/PaymentRuleModifications.locale';
import paymentLocale from '../widgets/payments/web/payments.locale';
import paymentTemplatesLocale from '../widgets/paymentTemplates/paymentTemplates.locale';
import pendingDecisions from '../pendingDecisions/pendingDecisions.locale';
import pendingDecisionsForm from '../pendingDecisionsForm/pendingDecisionsForm.locale';
import positivePayLocale from '../positivePay/positivePay.locale';
import quickTransferLocale from '../widgets/quickTransfer/quickTransfer.locale';
import recurringGrid from '../recurringTransfersGrid/recurringGrid.locale';
import recurringPayment from '../ach/Recurring/recurring.locale';
import recurringTransfer from '../recurringTransfer/recurring.locale';
import recurringTransferWorkflow from '../recurringTransferWorkflow/recurringTransfer.locale';
import resetPasswordLocale from '../resetPassword/resetPassword.locale';
import reviewImport from '../reviewImport/reviewImport.locale';
import reviewTransferLocale from '../reviewTransfer/ReviewTransfer.locale';
import securityChallengeLocale from '../securityChallenge/securityChallenge.locale';
import securityInformationLocale from '../securityInformation/securityInformation.locale';
import quickLinks from '../widgets/quickLinks/quickLinks.locale';
import sendPayments from '../sendPayment/sendPayments.locale';
import sessionExpiration from '../sessionExpiration/sessionExpiration.locale';
import sideNav from '../sideNav/sideNav.locale';
import smallBusinessPayments from '../widgets/smallBusinessPayments/smallBusinessPayments.locale';
import smartChartLocale from '../widgets/smartChart/SmartChart.locale';
import ssoModal from '../ssoWorkflow/ssoModal.locale';
import ssoErrorLocale from '../ssoError/ssoError.locale';
import statementGridLocale from '../statementGrid/statementGrid.locale';
import statementLocale from '../widgets/statementSearch/statement.locale';
import stopPaymentRequest from '../stopPaymentRequest/stopPaymentRequest.locale';
import stopPaymentRequests from '../stopPaymentRequests/stopPaymentsRequests.locale';
import stopPaymentsLocale from '../widgets/stopPayments/stopPayments.locale';
import systemCodeLocale from './systemCode.locale';
import termsAndConditionsLocale from '../termsAndConditions/termsAndConditions.locale';
import totalHeaderDetails from '../totalHeaderDetails/TotalHeaderDetails.locale';
import transactionDetails from '../transactionDetails/transactionDetails.locale';
import transactionReporting from '../transactionReporting/transactionReporting.locale';
import transactionReportingForm from '../transactionReporting/transactionReportingForm.locale';
import transactionSearch from '../widgets/transactionSearch/transactionSearch.locale';
import transfersLocale from '../transfers/transfers.locale';
import transferTemplatesGrid from '../transferTemplatesGrid/transferTemplatesGrid.locale';
import infuse from '../../infuse/InfuseHandShakeScreen.locale';
import userEmulationLocale from '../userEmulation/UserEmulation.locale';
import userInformationLocale from '../userInformation/userInformation.locale';
import userMaintenanceLocale from '../widgets/userMaintenance/userMaintenance.locale';
import userPendingChangesLocale from '../userPendingChanges/userPengingChanges.locale';
import challengeManagerLocale from '../challengeManager/ChallengeManager.locale';
import validationLocale from './validation.locale';
import viewCriteriaLocale from '../viewCriteria/viewCriteria.locale';
import viewFileDetails from '../viewFileDetails/viewFileDetails.locale';
import viewPaymentLocale from '../ViewPaymentDir/wire/viewPayment.locale';
import viewStopPaymentsLocale from '../viewStopPayments/viewStopPayments.locale';
import viewTemplateLocale from '../viewTemplate/viewTemplate.locale';
import viewTransfersLocale from '../viewTransfers/viewTransfers.locale';
import viewWireFileSummaryLocale from '../viewWireFileSummary/viewWireFileSummary.locale';
import weekday from '../weekdayCheckboxes/weekday.locale';
import widgetMenuLocale from '../widgetMenuToggle/widgetMenuToggle.locale';
import wireImports from '../widgets/wireImports/WireImports.locale';
import wirePayment from '../wirePayment/wirePayment.locale';
import wires from '../wires/wire.locale.ts';
import incomingWireDetail from '../incomingWireDetail/IncomingWireDetail.locale';
import loanPayment from '../loanPayment/loanPayment.locale';
import importTransfer from '../importManager/importTransfer.locale';
import payeeImport from '../widgets/contactCenterListView/PayeeImport/PayeeImport.locale';
import marketingMessages from '../marketingMessages/marketingMessages.locale';

export default {
  ...accountActivity,
  ...accountDetails,
  ...accountSummaryWidget,
  ...ach,
  ...achPayment,
  ...achPosPay,
  ...achTotals,
  ...addContactLocale,
  ...alertsList,
  ...allAccounts,
  ...assignAlerts,
  ...assignServices,
  ...auditReport,
  ...balanceAndTransactions,
  ...balanceTransactionSearchForm,
  ...beforeAfterDayRadio,
  ...btrAccountsDropDown,
  ...bulletinsLocale,
  'button.acceptDisclosure': 'Accept',
  'button.declineDisclosure': 'Decline',
  'button.emailDisclosure': 'Email',
  'button.printDisclosure': 'Print',
  'button.signIn': 'Sign In',
  'button.logIn': 'Log In',
  ...cashFlowForecastingLocale,
  ...challengeManagerLocale,
  ...checkImageDetails,
  ...checkIssueManagementLocale,
  ...commonLocale,
  ...contactCenterLocale,
  ...contactCenterApprovePayeeLocale,
  ...contactCenterListViewLocale,
  ...createPaymentLocale,
  ...contactCenterApprovePayeeLocale,
  ...contactCenterUserLocale,
  ...createTransfersLocale,
  ...customReporting,
  // Dates seem like a universal usage
  // Should move to a dateTime.locale
  ...dateTimeLocale,
  ...daymonthorweek,
  ...deliveryPoints,
  ...depositAccountDetailsLocale,
  ...depositAccountsLocale,
  ...depositSlip,
  ...deviceChallengeLocale,
  ...dropZoneLocale,
  ...dynamicLink2,
  ...electronicreportsGridLocale,
  ...employeePaymentsLocale,
  ...failedImportDetailsLocale,
  ...FdicLogoLocale,
  ...financialOverviewLocale,
  ...firstTimeLoginFlowLocale,
  'function.ChangePwd': 'Change Password',
  'function.MySettings': 'Profile Maintenance',
  ...gridDatePicker,
  'header.help': 'Help Center',
  'header.lastsync': 'As of',
  'header.logoff': 'Log Out',
  'header.nouserhist': 'No user history',
  ...importBatchesGrid,
  ...importFile,
  ...importTransfer,
  ...importIssueFiles,
  ...importIssueDetails,
  ...importMapping,
  ...importPayment,
  ...importBatchLocale,
  ...incomingWireDetail,
  ...initiateForm,
  ...issuesVoids,
  ...limits,
  ...loanAccountDetails,
  ...loanAccountDetailsTabs,
  ...loanAccountsLocale,
  ...loanPaymentTemplateWorkflow,
  ...login,
  'login.contactUs': 'Contact us for assistance',
  'logon.forgotten.system.error':
    'You are unable to use the forgotten password feature at this time. Please contact your system administrator for assistance.',
  'logon.forgotten.system.warning': 'Both Customer ID and User ID are required',
  'logon.help': 'Need Help Logging In?',
  'logon.prompt.leadBankCode': 'Lead Bank Code',
  'logon.prompt.password': 'Password',
  'logon.prompt.rememberIds': 'Remember IDs',
  'logon.prompt.userCode': 'User ID',
  'logon.prompt.sso.userCode': 'User Code',
  'logon.prompt.usergroup': 'Customer ID',
  'logon.prompt.sso.usergroup': 'Customer Code',
  'menuitem.SETUP.SecQues': 'Security Questions',
  'menuitem.SETUP.ManageSecQues': 'Change Security Questions',
  ...mobileRemoteDepositCheckCapture,
  ...monthlyscheduler,
  ...newUser,
  ...nicknames,
  ...notifications,
  'payment.amount': 'Amount',
  'payment.cancel': 'Cancel',
  'payment.saveForLater': 'Save for Later',
  'payment.submit': 'Submit',
  ...paymentFraudControlGridLocale,
  ...paymentFraudControlLocale,
  ...paymentFraudControlSummaryGridLocale,
  ...paymentRuleModificationsLocale,
  ...paymentLocale,
  ...pendingDecisions,
  ...pendingDecisionsForm,
  ...positivePayLocale,
  'prompt.confirmPassword': 'Repeat New Password',
  'prompt.newPassword': 'New Password',
  'prompt.oldPassword': 'Current Password',
  ...paymentTemplatesLocale,
  ...paymentAdditionalDetails,
  ...paymentDetails,
  ...paymentRule,
  ...payeeImport,
  ...quickTransferLocale,
  ...recurringGrid,
  ...recurringPayment,
  ...recurringTransfer,
  ...recurringTransferWorkflow,
  ...resetPasswordLocale,
  ...reviewImport,
  ...reviewTransferLocale,
  ...quickLinks,
  ...securityChallengeLocale,
  ...securityInformationLocale,
  ...sendPayments,
  ...loanPayment,
  ...sessionExpiration,
  ...sideNav,
  ...smallBusinessPayments,
  ...smartChartLocale,
  ...ssoModal,
  ...ssoErrorLocale,
  ...statementGridLocale,
  ...statementLocale,
  ...stopPaymentRequest,
  ...stopPaymentRequests,
  ...stopPaymentsLocale,
  ...systemCodeLocale,
  'system.lastLogin': 'Last Login:',
  ...termsAndConditionsLocale,
  ...totalHeaderDetails,
  ...transactionDetails,
  ...transactionReporting,
  ...transactionReportingForm,
  ...transactionSearch,
  ...TransferServiceMessage,
  ...transfersLocale,
  ...transferTemplatesGrid,
  ...infuse,
  ...userEmulationLocale,
  ...userInformationLocale,
  ...userMaintenanceLocale,
  ...userPendingChangesLocale,
  ...validationLocale,
  ...viewCriteriaLocale,
  ...viewFileDetails,
  ...viewStopPaymentsLocale,
  ...viewPaymentLocale,
  ...viewTemplateLocale,
  ...viewTransfersLocale,
  ...viewWireFileSummaryLocale,
  ...viewFileImport,
  ...weekday,
  ...widgetMenuLocale,
  ...wireImports,
  ...wirePayment,
  ...wireImports,
  ...wires,
  ...controlledDisbursementsWidgetLocale,
  ...controlledDisbursementsGridLocale,
  ...marketingMessages,
  ...checkfreeLocale,
  ...smbLoanTemplate
};
